module.exports = __webpack_public_path__ + "imgs/findus.10b1ad1f85a6fb6934cb627dc9261df1.svg";